import React, { useState } from 'react';

const EditableField = ({ field_id, field, value, confidence, cost, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (editValue !== value) {
      setSaving(true);
      try {
        await onUpdate(field_id, value, editValue);
        setIsEditing(false);
      } catch (err) {
        console.error('Save error:', err);
        alert('Erreur lors de la sauvegarde');
      } finally {
        setSaving(false);
      }
    } else {
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setEditValue(value);
    setIsEditing(false);
  };

  const confidenceColor = confidence >= 0.8 ? 'text-green-400' : confidence >= 0.6 ? 'text-yellow-400' : 'text-red-400';

  return (
    <div className="bg-slate-700/50 border border-slate-600 rounded-lg p-4 hover:border-blue-500/50 transition">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <h4 className="font-semibold text-white mb-2">{field}</h4>
          
          {isEditing ? (
            <div className="space-y-2">
              <textarea
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                className="w-full px-3 py-2 bg-slate-800 border border-blue-500 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="2"
                autoFocus
              />
              <div className="flex gap-2">
                <button
                  onClick={handleSave}
                  disabled={saving}
                  className="px-4 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm disabled:opacity-50"
                >
                  {saving ? 'Sauvegarde...' : 'Enregistrer'}
                </button>
                <button
                  onClick={handleCancel}
                  className="px-4 py-1 bg-slate-600 hover:bg-slate-500 text-white rounded text-sm"
                >
                  Annuler
                </button>
              </div>
            </div>
          ) : (
            <div className="space-y-2">
              <p className="text-slate-300">{value}</p>
              <button
                onClick={() => setIsEditing(true)}
                className="text-blue-400 hover:text-blue-300 text-sm"
              >
                Modifier
              </button>
            </div>
          )}
        </div>

        <div className="flex flex-col items-end gap-2">
          <span className={`text-sm font-semibold ${confidenceColor}`}>
            {(confidence * 100).toFixed(0)}%
          </span>
          {cost && (
            <span className="text-sm text-slate-400">{cost.toFixed(2)}€</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditableField;



